// GLOBAL CONSTANTS
// -----------------------------------
import {getCsCodeList, getCsCodeItem} from "../api/cs/CsCodeApi";
import service from "@/utils/request";

interface ValueText {
    value:string,
    text:string,
    data?:object
}

export class ValueTexts {
    constructor(public array:ValueText[]) {
        this.array = array;
    }
    getText(code:any) : string {
        if (code === 0 || code === '' || code == null) {
            return '';
        }
        const findItems : ValueText[] = this.array.filter(item => item.value === code);
        return findItems.length == 1 ? findItems[0].text : '';
    }
    // userType text 를 구하는 경우
    getUserTypeText(userTypeCds:any) : string {
        if (!userTypeCds){
            return '';
        }
        const userTypeList = userTypeCds.split(',');
        let retArray : string[] = [];
        userTypeList.forEach((userType:string) => {
            const findItems : ValueText[] = this.array.filter(item => item.value === userType);
            if (findItems.length == 1) {
                retArray.push(findItems[0].text);
            }
        })
        return retArray.length == 0 ? '' : retArray.join(',');
    }
    getData(code:any) : object|undefined {
        if (code === 0 || code === '' || code == null) {
            return undefined;
        }
        const findItems : ValueText[] = this.array.filter(item => item.value === code);
        return findItems.length == 1 ? findItems[0].data : undefined;
    }
    setArray(array:ValueText[]) {
        this.array = array;
    }
    get noEmptyArray() : ValueText[] {
        return this.array.filter(item => item.value != '' && item.value != null);
    }
}

// 권한 타입
export const roleTypeOption = new ValueTexts([
    {value:'102001', text:'일반'},
    {value:'102002', text:'마스터'}
]);

// 사용여부
export const useYn = [
    {value:'Y', text:'사용'},
    {value:'N', text:'미사용'}
]

// 채널 배너 위치 (교사채널)
export const teacherImageDivs = [
    {value:'', text:'전체'},
    {value:'206006', text:'메인-최상단 띠 배너'},
    {value:'206007', text:'메인-우측상단배너'},
    {value:'206008', text:'메인-팝업'},
    {value:'206010', text:'메인-탑배너(방학용)'},
    {value:'206009', text:'서브-원형플로팅배너'},
    {value:'206011', text:'서브-상단 띠 배너'},
];
// 채널 배너 위치 (교사 이외 채널)
export const otherImageDivs = teacherImageDivs.filter((item) => item.value != '206010');

export const useYnOption = new ValueTexts([
    {value:'', text:'전체'},
    {value:'Y', text:'사용'},
    {value:'N', text:'미사용'}
]);

export const dataObject = {
    params: {
        page: 1,
        limit: 10,
        mode: 'list',
        schStartDt: '',  // 검색 시작일
        schEndDt: '',    // 검색 종료일
        schType: '',
        schText: '',
        isLoading: false,
    },
    list: [],
    row: {},
    count: 0,
    codes: {
        useYn : useYn
    },

};

// export const aws_cdn_path = 'https://s3.ap-northeast-2.amazonaws.com/ybm-prd-std/';
// export const aws_cdn_stg_path = 'https://s3.ap-northeast-2.amazonaws.com/ybm-stg-std/';
export const aws_cdn_path = 'https://kr.object.ncloudstorage.com/ybm-prd-std/';
export const aws_cdn_stg_path = 'https://kr.object.ncloudstorage.com/ybm-stg-std/';

// 계정상태코드
export const acntStatCd = new ValueTexts([
    {value:'', text:'전체'},
    {value:'101001', text:'승인'},
    {value:'101002', text:'미승인'},
    {value:'101003', text:'반려'}
]);

export const bookTypeCd = [
    {value:'330001', text:'교과서'},
    {value:'330002', text:'참고서'},
    {value:'330003', text:'교사제작'},
]

export const subjectCd = [
    {value :'328001', refValue:'1020', text:'국어'},
    {value :'328002', refValue:'1001', text:'영어'},
    {value :'328003', refValue:'1013', text:'수학'},
    {value :'328004', refValue:'1019', text:'사회'},
    {value :'328005', refValue:'1024', text:'도덕'},
    {value :'328006', refValue:'1002', text:'과학'},
    {value :'328007', refValue:'1003', text:'음악'},
    {value :'328008', refValue:'1004', text:'미술'},
    {value :'328009', refValue:'1005', text:'체육'},
    {value :'328010', refValue:'1006', text:'보건'},
    {value :'328011', refValue:'1010', text:'진로와 직업'},
    {value :'328012', refValue:'1006', text:'실과'},
    {value :'328017', refValue:'1101', text:'인정교과'},
    {value :'328018', refValue:'1100', text:'전과목'},
    {value :'328019', refValue:'1009', text:'중국어'},
    {value :'328020', refValue:'1011', text:'정보'},
    {value :'328021', refValue:'1012', text:'논술'},
    {value :'328099', text:'기타'},
    {value :'328101', refValue:'1020', text:'국어'},
    {value :'328102', refValue:'1001', text:'영어'},
    {value :'328103', refValue:'1013', text:'수학'},
    {value :'328104', refValue:'1019', text:'사회'},
    {value :'328105', refValue:'1024', text:'도덕'},
    {value :'328106', refValue:'1002', text:'과학'},
    {value :'328107', refValue:'1003', text:'음악'},
    {value :'328108', refValue:'1004', text:'미술'},
    {value :'328109', refValue:'1005', text:'체육'},
    {value :'328110', refValue:'1006', text:'보건'},
    {value :'328111', refValue:'1010', text:'진로와 직업'},
    {value :'328112', refValue:'1009', text:'제2외국어'},
    {value :'328113', refValue:'1008', text:'한문'},
    {value :'328114', refValue:'1026', text:'역사'},
    {value :'328115', refValue:'1022', text:'기술-가정'},
    {value :'328116', refValue:'1011', text:'정보'},
    {value :'328117', refValue:'1101', text:'인정교과'},
    {value :'328119', refValue:'1009', text:'중국어'},
    {value :'328121', refValue:'1012', text:'논술'},
    {value :'328199', text:'기타'},
    {value :'328201', refValue:'1020', text:'국어'},
    {value :'328202', refValue:'1001', text:'영어'},
    {value :'328203', refValue:'1013', text:'수학'},
    {value :'328204', refValue:'1019', text:'사회'},
    {value :'328205', refValue:'1024', text:'도덕'},
    {value :'328206', refValue:'1002', text:'과학'},
    {value :'328207', refValue:'1003', text:'음악'},
    {value :'328208', refValue:'1004', text:'미술'},
    {value :'328209', refValue:'1005', text:'체육'},
    {value :'328210', refValue:'1007', text:'보건'},
    {value :'328211', refValue:'1010', text:'진로와 직업'},
    {value :'328212', refValue:'1009', text:'제2외국어'},
    {value :'328213', refValue:'1008', text:'한문'},
    {value :'328214', refValue:'1026', text:'역사'},
    {value :'328215', refValue:'1022', text:'기술가정'},
    {value :'328217', refValue:'1101', text:'인정교과'},
    {value :'328219', refValue:'1009', text:'중국어'},
    {value :'328220', refValue:'1011', text:'정보'},
    {value :'328221', refValue:'1012', text:'논술'},
    {value :'328299', refValue:'1012', text:'기타'},
]

export const subjectCd1 = [
    {value :"328001", refValue:'1020', text:'국어'},
    {value :"328002", refValue:'1001', text:'영어'},
    {value :"328003", refValue:'1013', text:'수학'},
    {value :"328004", refValue:'1019', text:'사회'},
    {value :"328005", refValue:'1024', text:'도덕'},
    {value :"328006", refValue:'1002', text:'과학'},
    {value :"328007", refValue:'1003', text:'음악'},
    {value :"328008", refValue:'1004', text:'미술'},
    {value :"328009", refValue:'1005', text:'체육'},
    {value :"328010", refValue:'1007', text:'보건'},
    {value :"328011", refValue:'1010', text:'진로와 직업'},
    {value :"328012", refValue:'1006', text:'실과'},
    {value :"328017", refValue:'1101', text:'인정교과'},
    {value :"328018", refValue:'1100', text:'전과목'},
    {value :'328019', refValue:'1009', text:'중국어'},
    {value :'328020', refValue:'1011', text:'정보'},
    {value :'328021', refValue:'1012', text:'논술'},
    {value :"328099", text:'기타'},
]
export const subjectCd2 = [
    {value :"328101", refValue:'1020', text:'국어'},
    {value :"328102", refValue:'1001', text:'영어'},
    {value :"328103", refValue:'1013', text:'수학'},
    {value :"328104", refValue:'1019', text:'사회'},
    {value :"328105", refValue:'1024', text:'도덕'},
    {value :"328106", refValue:'1002', text:'과학'},
    {value :"328107", refValue:'1003', text:'음악'},
    {value :"328108", refValue:'1004', text:'미술'},
    {value :"328109", refValue:'1005', text:'체육'},
    {value :"328110", refValue:'1007', text:'보건'},
    {value :"328111", refValue:'1010', text:'진로와 직업'},
    {value :"328112", refValue:'1009', text:'제2외국어'},
    {value :"328113", refValue:'1008', text:'한문'},
    {value :"328114", refValue:'1026', text:'역사'},
    {value :"328115", refValue:'1022', text:'기술-가정'},
    {value :"328116", refValue:'1011', text:'정보'},
    {value :"328117", refValue:'1101', text:'인정교과'},
    {value :'328119', refValue:'1009', text:'중국어'},
    {value :'328121', refValue:'1012', text:'논술'},
    {value :"328199", text:'기타'},
]
export const subjectCd3 = [
    {value :"328201", refValue:'1020', text:'국어'},
    {value :"328202", refValue:'1001', text:'영어'},
    {value :"328203", refValue:'1013', text:'수학'},
    {value :"328204", refValue:'1019', text:'사회'},
    {value :"328205", refValue:'1024', text:'도덕'},
    {value :"328206", refValue:'1002', text:'과학'},
    {value :"328207", refValue:'1003', text:'음악'},
    {value :"328208", refValue:'1004', text:'미술'},
    {value :"328209", refValue:'1005', text:'체육'},
    {value :"328210", refValue:'1007', text:'보건'},
    {value :"328211", refValue:'1010', text:'진로와 직업'},
    {value :"328212", refValue:'1009', text:'제2외국어'},
    {value :"328213", refValue:'1008', text:'한문'},
    {value :"328214", refValue:'1026', text:'역사'},
    {value :"328215", refValue:'1022', text:'기술가정'},
    {value :"328217", refValue:'1101', text:'인정교과'},
    {value :'328219', refValue:'1009', text:'중국어'},
    {value :'328220', refValue:'1011', text:'정보'},
    {value :'328221', refValue:'1012', text:'논술'},
    {value :"328299", refValue:'1012', text:'기타'},
]
export const cateCd = [
    {value :"356001", text:'초등학교'},
    {value :"356002", text:'중학교'},
    {value :"356003", text:'고등학교'},
    {value :"356004", text:'교과서'},
    {value :"356005", text:'ELT'},
]
export const RsubjectCd = [
    {value :"328301", text:'어휘'},
    {value :"328302", text:'듣기'},
    {value :"328303", text:'문법/구문'},
    {value :"328304", text:'독해'},
    {value :"328305", text:'회화'},
    {value :"328306", text:'기타 외국어 및 일반'},
    {value :"328307", text:'평가문제집/자습서'},
    {value :"328308", text:'수학'},
    {value :"328309", text:'수험서'},
    {value :"328310", text:'예비초등'},
    {value :"328311", text:'유아'},
    {value :"328312", text:'교구재'},
    {value :"328313", text:'일반 단행본'},
    {value :"328401", text:'어휘'},
    {value :"328402", text:'듣기'},
    {value :"328403", text:'평가문제집/자습서'},
    {value :"328404", text:'쓰기'},
    {value :"328405", text:'독해'},
    {value :"328406", text:'문법/구문'},
    {value :"328407", text:'수험서'},
    {value :"328408", text:'수학'},
    {value :"328409", text:'기타 외국어 및 일반'},
    {value :"328410", text:'일반 단행본'},
    {value :"328501", text:'어휘'},
    {value :"328502", text:'듣기'},
    {value :"328503", text:'문법/구문'},
    {value :"328504", text:'독해'},
    {value :"328505", text:'단기 특강'},
    {value :"328506", text:'수능대비'},
    {value :"328507", text:'모의고사'},
    {value :"328508", text:'수학'},
    {value :"328509", text:'기타 외국어 및 일반'},
    {value :"328510", text:'평가문제집/자습서'},
    {value :"328511", text:'일반 단행본'},
    {value :"328601", text:'초등 교과서/지도서'},
    {value :"328602", text:'초등 평가문제집/자습서'},
    {value :"328603", text:'중등 교과서/지도서'},
    {value :"328604", text:'중등 평가문제집/자습서'},
    {value :"328605", text:'고등 교과서/지도서'},
    {value :"328606", text:'고등 평가문제집/자습서'},
    {value :"328701", text:'Benchmark Reading'},
    {value :"328702", text:'US School Program'},
    {value :"328703", text:'Four-Skill Course'},
    {value :"328704", text:'Business'},
    {value :"328705", text:'Multi-Skill Course'},
    {value :"328706", text:'Reading'},
    {value :"328707", text:'Listening'},
    {value :"328708", text:'Writing'},
    {value :"328709", text:'Grammar'},
    {value :"328710", text:'Vocabulary'},
    {value :"328711", text:'Phonics'},
    {value :"328712", text:'Readers'},
]
export const RsubjectCd1 = [
    {value :"328301", text:'어휘'},
    {value :"328302", text:'듣기'},
    {value :"328303", text:'문법/구문'},
    {value :"328304", text:'독해'},
    {value :"328305", text:'회화'},
    {value :"328306", text:'기타 외국어 및 일반'},
    {value :"328307", text:'평가문제집/자습서'},
    {value :"328308", text:'수학'},
    {value :"328309", text:'수험서'},
    {value :"328310", text:'예비초등'},
    {value :"328311", text:'유아'},
    {value :"328312", text:'교구재'},
    {value :"328313", text:'일반 단행본'},

]
export const RsubjectCd2 = [
    {value :"328401", text:'어휘'},
    {value :"328402", text:'듣기'},
    {value :"328403", text:'평가문제집/자습서'},
    {value :"328404", text:'쓰기'},
    {value :"328405", text:'독해'},
    {value :"328406", text:'문법/구문'},
    {value :"328407", text:'수험서'},
    {value :"328408", text:'수학'},
    {value :"328409", text:'기타 외국어 및 일반'},
    {value :"328410", text:'일반 단행본'},
]
export const RsubjectCd3 = [
    {value :"328501", text:'어휘'},
    {value :"328502", text:'듣기'},
    {value :"328503", text:'문법/구문'},
    {value :"328504", text:'독해'},
    {value :"328505", text:'단기 특강'},
    {value :"328506", text:'수능대비'},
    {value :"328507", text:'모의고사'},
    {value :"328508", text:'수학'},
    {value :"328509", text:'기타 외국어 및 일반'},
    {value :"328510", text:'평가문제집/자습서'},
    {value :"328511", text:'일반 단행본'},
]
export const RsubjectCd4 = [
    {value :"328601", text:'초등 교과서/지도서'},
    {value :"328602", text:'초등 평가문제집/자습서'},
    {value :"328603", text:'중등 교과서/지도서'},
    {value :"328604", text:'중등 평가문제집/자습서'},
    {value :"328605", text:'고등 교과서/지도서'},
    {value :"328606", text:'고등 평가문제집/자습서'},
]
export const RsubjectCd5 = [
    {value :"328701", text:'Benchmark Reading'},
    {value :"328702", text:'US School Program'},
    {value :"328703", text:'Four-Skill Course'},
    {value :"328704", text:'Business'},
    {value :"328705", text:'Multi-Skill Course'},
    {value :"328706", text:'Reading'},
    {value :"328707", text:'Listening'},
    {value :"328708", text:'Writing'},
    {value :"328709", text:'Grammar'},
    {value :"328710", text:'Vocabulary'},
    {value :"328711", text:'Phonics'},
    {value :"328712", text:'Readers'},
]
// 학교급 코드 schoolDivCd
export const schoolDivCd = [
    {value : '301001', text:'일반'},
    {value : '301002', text:'초등학교'},
    {value : '301003', text:'중학교'},
    {value : '301004', text:'고등학교'},
    {value : '301005', text:'특수학교'},
    {value : '301007', text:'각종학교(고등공민학교)'},
    {value : '301008', text:'각종학교(특성화고등학교)'},
    {value : '301009', text:'각종학교'},
    {value : '301010', text:'각종학교'},
    {value : '301011', text:'각종학교(부설방송통신고등학교)'},
    {value : '301019', text:'각종학교'},
    {value : '301025', text:'각종학교(부설방송통신중학교)'},
    {value : '301099', text:'기타'},
    {value : '321001', text:'YBM'},
    {value : '339001', text:'학원'},
    {value : '339002', text:'교습소'},
]

export const schoolGrdCdOption = [
    {value:'',text:'전체'},
    {value:'301002',text:'초등'},
    {value:'301003',text:'중등'},
    {value:'301004',text:'고등'}
]

export function getSchoolDivName(code:any) {
    const findItems : {value:string, text:string}[] = schoolDivCd.filter(item => item.value === code);
    return findItems.length == 1 ? findItems[0].text : '';
}

// 컨텐츠용도 코드 purpTypeCd
export const purpTypeCd = [
    {value : '', text:'용도코드 없음'},
    {value : '209001', text:'수업용1'},
    {value : '209002', text:'수업용2'},
    {value : '209003', text:'과제용'},
    {value : '209004', text:'평가용'},
    {value : '209005', text:'연구용'}
]

// 컨텐츠용도 코드 purpTypeCd (외부링크용)
export const purpTypeCd_exterUrl = [
    {value : '', text:'용도코드 없음'},
    {value : '209001', text:'수업용1'},
    {value : '209002', text:'수업용2'},
    {value : '209003', text:'과제용'},
    {value : '209004', text:'평가용'},
    {value : '209005', text:'연구용'},
    {value : '209007', text:'부가자료'}
]
// 20250207
export const purpTypeCd_exterUrl_sub = [
    { value: "601001", p_code: "209007", text: "과목연구실", code_desc: "[와클게시판] 대분류" },
    { value: "601002", p_code: "209007", text: "기초학력자료", code_desc: "[와클게시판] 대분류" },
    { value: "602001", p_code: "209007,601001", text: "영어", code_desc: "[와클게시판] 과목" },
    { value: "602002", p_code: "209007,601001", text: "수학", code_desc: "[와클게시판] 과목" },
    { value: "602003", p_code: "209007,601001", text: "사회", code_desc: "[와클게시판] 과목" },
    { value: "602004", p_code: "209007,601001", text: "과학", code_desc: "[와클게시판] 과목" },
    { value: "602005", p_code: "209007,601001", text: "음악", code_desc: "[와클게시판] 과목" },
    { value: "602006", p_code: "209007,601001", text: "체육", code_desc: "[와클게시판] 과목" },
    { value: "602007", p_code: "209007,601001", text: "미술", code_desc: "[와클게시판] 과목" },
    { value: "602008", p_code: "209007,601001", text: "공통", code_desc: "[와클게시판] 과목" },
    { value: "603001", p_code: "209007,601002", text: "영어", code_desc: "[와클게시판] 과목" },
    { value: "603002", p_code: "209007,601002", text: "매일완북", code_desc: "[와클게시판] 과목" },
    { value: "603003", p_code: "209007,601002", text: "국어", code_desc: "[와클게시판] 과목" },
    { value: "603004", p_code: "209007,601002", text: "수학", code_desc: "[와클게시판] 과목" },
    { value: "603005", p_code: "209007,601002", text: "사회", code_desc: "[와클게시판] 과목" },
    { value: "603006", p_code: "209007,601002", text: "과학", code_desc: "[와클게시판] 과목" },
    { value: "604001", p_code: "209007,601001,602001", text: "English Song", code_desc: "[와클게시판] 카테고리" },
    { value: "604002", p_code: "209007,601001,602001", text: "Magic English", code_desc: "[와클게시판] 카테고리" },
    { value: "604003", p_code: "209007,601001,602001", text: "미술로 배우는 영어", code_desc: "[와클게시판] 카테고리" },
    { value: "604004", p_code: "209007,601001,602001", text: "영어 동화", code_desc: "[와클게시판] 카테고리" },
    { value: "604005", p_code: "209007,601001,602001", text: "영어 동아리 활동", code_desc: "[와클게시판] 카테고리" },
    { value: "604006", p_code: "209007,601001,602001", text: "영어 그림책 만들기 활동", code_desc: "[와클게시판] 카테고리" },
    { value: "604007", p_code: "209007,601001,602001", text: "놀이꾸러미(일일학습지)", code_desc: "[와클게시판] 카테고리" },
    { value: "604008", p_code: "209007,601001,602001", text: "주제별&기능별 학습 자료", code_desc: "[와클게시판] 카테고리" },
    { value: "605001", p_code: "209007,601001,602002", text: "차시별 개념 짤강", code_desc: "[와클게시판] 카테고리" },
    { value: "605002", p_code: "209007,601001,602002", text: "생활 속의 수학", code_desc: "[와클게시판] 카테고리" },
    { value: "605003", p_code: "209007,601001,602002", text: "단원별 동기유발 자료", code_desc: "[와클게시판] 카테고리" },
    { value: "605004", p_code: "209007,601001,602002", text: "주제별&활동별 학습 자료", code_desc: "[와클게시판] 카테고리" },
    { value: "605005", p_code: "209007,601001,602002", text: "오개념 바로잡기", code_desc: "[와클게시판] 카테고리" },
    { value: "605006", p_code: "209007,601001,602002", text: "보드게임으로 즐기는 수학", code_desc: "[와클게시판] 카테고리" },
    { value: "605007", p_code: "209007,601001,602002", text: "연산 짤강", code_desc: "[와클게시판] 카테고리" },
    { value: "606001", p_code: "209007,601001,602003", text: "사회 정리 퀴즈", code_desc: "[와클게시판] 카테고리" },
    { value: "606002", p_code: "209007,601001,602003", text: "[몽당분필] 사회 개념 쏙쏙 영상", code_desc: "[와클게시판] 카테고리" },
    { value: "606003", p_code: "209007,601001,602003", text: "주제별 수업 자료집", code_desc: "[와클게시판] 카테고리" },
    { value: "606004", p_code: "209007,601001,602003", text: "지도 활동지", code_desc: "[와클게시판] 카테고리" },
    { value: "607001", p_code: "209007,601001,602004", text: "과학 정리 퀴즈", code_desc: "[와클게시판] 카테고리" },
    { value: "608001", p_code: "209007,601001,602005", text: "음악 이론", code_desc: "[와클게시판] 카테고리" },
    { value: "608002", p_code: "209007,601001,602005", text: "음악 수업 비법", code_desc: "[와클게시판] 카테고리" },
    { value: "608003", p_code: "209007,601001,602005", text: "악기 연주법", code_desc: "[와클게시판] 카테고리" },
    { value: "608004", p_code: "209007,601001,602005", text: "악곡 자료", code_desc: "[와클게시판] 카테고리" },
    { value: "608005", p_code: "209007,601001,602005", text: "교과서 국악", code_desc: "[와클게시판] 카테고리" },
    { value: "608006", p_code: "209007,601001,602005", text: "딩동댕 음악 수업", code_desc: "[와클게시판] 카테고리" },
    { value: "608007", p_code: "209007,601001,602005", text: "음악 속 이야기", code_desc: "[와클게시판] 카테고리" },
    { value: "608008", p_code: "209007,601001,602005", text: "세계 민속 악기 만들기", code_desc: "[와클게시판] 카테고리" },
    { value: "608009", p_code: "209007,601001,602005", text: "(서울 시향과 함께하는) 음악 여행", code_desc: "[와클게시판] 카테고리" },
    { value: "609001", p_code: "209007,601001,602006", text: "체육 퀴즈", code_desc: "[와클게시판] 카테고리" },
    { value: "609002", p_code: "209007,601001,602006", text: "스포츠 속 재미있는 이야기", code_desc: "[와클게시판] 카테고리" },
    { value: "609003", p_code: "209007,601001,602006", text: "체육 수업 디자인하기", code_desc: "[와클게시판] 카테고리" },
    { value: "609004", p_code: "209007,601001,602006", text: "교실 체육", code_desc: "[와클게시판] 카테고리" },
    { value: "609005", p_code: "209007,601001,602006", text: "움직임 기술", code_desc: "[와클게시판] 카테고리" },
    { value: "609006", p_code: "209007,601001,602006", text: "뉴스포츠", code_desc: "[와클게시판] 카테고리" },
    { value: "609007", p_code: "209007,601001,602006", text: "표현 움직임 활동", code_desc: "[와클게시판] 카테고리" },
    { value: "609008", p_code: "209007,601001,602006", text: "체육 활동 길잡이", code_desc: "[와클게시판] 카테고리" },
    { value: "610001", p_code: "209007,601001,602007", text: "해 볼까? 미술 활동", code_desc: "[와클게시판] 카테고리" },
    { value: "610002", p_code: "209007,601001,602007", text: "꿀잼 명화 퀴즈", code_desc: "[와클게시판] 카테고리" },
    { value: "610003", p_code: "209007,601001,602007", text: "드로잉 노트, 이렇게 그려요", code_desc: "[와클게시판] 카테고리" },
    { value: "610004", p_code: "209007,601001,602007", text: "명화 컬러링", code_desc: "[와클게시판] 카테고리" },
    { value: "610005", p_code: "209007,601001,602007", text: "명화 이야기", code_desc: "[와클게시판] 카테고리" },
    { value: "611001", p_code: "209007,601001,602008", text: "생태전환교육", code_desc: "[와클게시판] 카테고리" },
    { value: "611002", p_code: "209007,601001,602008", text: "즐거운 학교 생활", code_desc: "[와클게시판] 카테고리" },
    { value: "611003", p_code: "209007,601001,602008", text: "쉬는 시간 퀴즈", code_desc: "[와클게시판] 카테고리" },
    { value: "612001", p_code: "209007,601002,603001", text: "알파벳", code_desc: "[와클게시판] 카테고리" },
    { value: "612002", p_code: "209007,601002,603001", text: "파닉스", code_desc: "[와클게시판] 카테고리" },
    { value: "612003", p_code: "209007,601002,603001", text: "영단어", code_desc: "[와클게시판] 카테고리" },
    { value: "612004", p_code: "209007,601002,603001", text: "영어 표현", code_desc: "[와클게시판] 카테고리" },
    { value: "613001", p_code: "209007,601002,603002", text: "매일완북", code_desc: "[와클게시판] 카테고리" },
    { value: "614001", p_code: "209007,601002,603003", text: "한글", code_desc: "[와클게시판] 카테고리" },
    { value: "614002", p_code: "209007,601002,603003", text: "교과서 어휘", code_desc: "[와클게시판] 카테고리" },
    { value: "614003", p_code: "209007,601002,603003", text: "맞춤법", code_desc: "[와클게시판] 카테고리" },
    { value: "615001", p_code: "209007,601002,603004", text: "수와 연산", code_desc: "[와클게시판] 카테고리" },
    { value: "615002", p_code: "209007,601002,603004", text: "도형", code_desc: "[와클게시판] 카테고리" },
    { value: "615003", p_code: "209007,601002,603004", text: "측정", code_desc: "[와클게시판] 카테고리" },
    { value: "615004", p_code: "209007,601002,603004", text: "도형과 측정", code_desc: "[와클게시판] 카테고리" },
    { value: "615005", p_code: "209007,601002,603004", text: "자료와 가능성", code_desc: "[와클게시판] 카테고리" },
    { value: "615006", p_code: "209007,601002,603004", text: "규칙성", code_desc: "[와클게시판] 카테고리" },
    { value: "616001", p_code: "209007,601002,603005", text: "용어 마스터", code_desc: "[와클게시판] 카테고리" },
    { value: "616002", p_code: "209007,601002,603005", text: "개념 마스터", code_desc: "[와클게시판] 카테고리" },
    { value: "617001", p_code: "209007,601002,603006", text: "용어 마스터", code_desc: "[와클게시판] 카테고리" },
    { value: "617002", p_code: "209007,601002,603006", text: "개념 마스터", code_desc: "[와클게시판] 카테고리" }
]

export function getPurpTypeName(code:any) {
    const findItems : {value:string, text:string}[] = purpTypeCd.filter(item => item.value === code);
    return findItems.length == 1 ? (findItems[0].value == '' ? '' : findItems[0].text) : '';
}

export const fileDivCd = [
    {value : '', text:''},
    {value : '208001', text:'YCLOUD컨텐츠'},
    {value : '208002', text:'BOOKSAM컨텐츠'},
    {value : '208003', text:'SMARTSCHOOL컨텐츠'},
    {value : '208009', text:'파일링크'},
    {value : '208010', text:'교재'},
    {value : '208011', text:'교재썸네일'}
]

export const fileDivCdMap = new Map(
    [
        ["208001", "YCLOUD컨텐츠"],
        ["208002", "BOOKSAM컨텐츠"],
        ["208003", "SMARTSCHOOL컨텐츠"],
        ['208009', '파일링크'],
        ['208010', '교재'],
        ['208011', '교재썸네일']
    ]
);

export function getFileDivName(code:any) {
    const findItems : {value:string, text:string}[] = fileDivCd.filter(item => item.value === code);
    return findItems.length == 1 ? findItems[0].text : '';
}

export const userTypeCd = [
    {value : '', text:'전체'},
    {value : '105002', text:'학교교사'},
    {value : '105003', text:'학원강사'},
    {value : '105005', text:'학생'},
    {value : '105006', text:'학부모'},
]

export const warnUserTypes = new ValueTexts([
    {value : '105002', text:'교사채널'},
    {value : '105003', text:'강사채널'},
]);

export const contentsUserTypes = new ValueTexts([
    {value : '105002', text:'교사채널'},
    {value : '105003', text:'강사채널'},
]);

// 신고 게시글 Topic
export const warnTopicOption = new ValueTexts([
    {value:'', text:'전체'},
    {value:'364002', text:'나눔자료'},
    {value:'364003', text:'이슈톡'},
    {value:'364004', text:'프리톡'},
    {value:'364005', text:'온라인콘텐츠'},
    {value:'364006', text:'이슈톡의견'},
]);

// 신고 댓글 Topic
export const warnCommentTopicOption = new ValueTexts([
    {value:'', text:'전체'},
    //{value:'361001', text:'그룹메시지'},
    //{value:'361002', text:'1:1메시지'},
    {value:'361003', text:'나눔자료'},
    {value:'361004', text:'이슈톡'},
    {value:'361005', text:'프리톡'},
    //{value:'361006', text:'기타작업'},
]);

export const warnStatusOption = new ValueTexts([
    {value:'', text:'전체'},
    {value:'368001', text:'접수'},
    {value:'368002', text:'노출'},
    {value:'368003', text:'비노출'},
]);

// 금칙어
export const badWordStatusOption = new ValueTexts([
    {value:'Y', text:'적용'},
    {value:'N', text:'미적용'}
])

// 댓글 전체 Topic
export const allCommentTopicOption = new ValueTexts([
    {value:'', text:'전체'},
    //{value:'361001', text:'그룹메시지'},
    //{value:'361002', text:'1:1메시지'},
    {value:'361003', text:'나눔자료'},
    {value:'361004', text:'이슈톡'},
    {value:'361005', text:'프리톡'},
    //{value:'361006', text:'기타작업'},
]);

export const allSchoolItems = [{key:'schlE1ChkYn', text:'초1'}, {key:'schlE2ChkYn', text:'초2'}, {key:'schlE3ChkYn', text:'초3'},
{key:'schlE4ChkYn', text:'초4'}, {key:'schlE5ChkYn', text:'초5'}, {key:'schlE6ChkYn', text:'초6'},
{key:'schlM1ChkYn', text:'중1'}, {key:'schlM2ChkYn', text:'중2'}, {key:'schlM3ChkYn', text:'중3'},
{key:'schlH1ChkYn', text:'고1'}, {key:'schlH2ChkYn', text:'고2'}, {key:'schlH3ChkYn', text:'고3'}];

export function getSchoolGradeName(item:any) {
    let schlNames:string[] = [];
    allSchoolItems.forEach((schItem) => {
        if (item[schItem.key] === 'Y') {
            schlNames.push(schItem.text);
        }
    });

    if (schlNames.length == 0) {
        return '';
    } else {
        return schlNames.join(' ');
    }
}

export function getUserTypeName(code:any) {
    const findItems : {value:string, text:string}[] = userTypeCd.filter(item => item.value === code);
    return findItems.length == 1 ? findItems[0].text : '';
}

export const fileTypeCd = [
    {value : '', text:'전체'},
    {value : '211001', text:'문서파일'},
    {value : '211002', text:'멀티미디어(MP3,MP4등)'},
    {value : '211003', text:'외부링크'},
    {value : '211004', text:'웹콘텐츠 링크'},
    {value : '211005', text:'웹콘텐츠 등록(zip)'},
    {value : '211006', text:'온라인콘텐츠만들기'},
]

export function getFileTypeName(code:any) {
    const findItems : {value:string, text:string}[] = fileTypeCd.filter(item => item.value === code);
    return findItems.length == 1 ? findItems[0].text : '';
}

// 메시지 타입
export const messageSendTypes = new ValueTexts([
    {value:'', text:'전체'},
    {value:'318002', text:'SMS'},
    {value:'318001', text:'E-MAIL'},
    {value:'318003', text:'APP PUSH', notEnabled:true},
    {value:'318004', text:'WEB 알림'}
  ]);

export const monthOption = [
    {value :'1', text:'1월'},
    {value :'2', text:'2월'},
    {value :'3', text:'3월'},
    {value :'4', text:'4월'},
    {value :'5', text:'5월'},
    {value :'6', text:'6월'},
    {value :'7', text:'7월'},
    {value :'8', text:'8월'},
    {value :'9', text:'9월'},
    {value :'10', text:'10월'},
    {value :'11', text:'11월'},
    {value :'12', text:'12월'},
]

export const day30 = [
    {value :'1', text:'1일'},
    {value :'2', text:'2일'},
    {value :'3', text:'3일'},
    {value :'4', text:'4일'},
    {value :'5', text:'5일'},
    {value :'6', text:'6일'},
    {value :'7', text:'7일'},
    {value :'8', text:'8일'},
    {value :'9', text:'9일'},
    {value :'10', text:'10일'},
    {value :'11', text:'11일'},
    {value :'12', text:'12일'},
    {value :'13', text:'13일'},
    {value :'14', text:'14일'},
    {value :'15', text:'15일'},
    {value :'16', text:'16일'},
    {value :'17', text:'17일'},
    {value :'18', text:'18일'},
    {value :'19', text:'19일'},
    {value :'20', text:'20일'},
    {value :'21', text:'21일'},
    {value :'22', text:'22일'},
    {value :'23', text:'23일'},
    {value :'24', text:'24일'},
    {value :'25', text:'25일'},
    {value :'26', text:'26일'},
    {value :'27', text:'27일'},
    {value :'28', text:'28일'},
    {value :'29', text:'29일'},
    {value :'30', text:'30일'},
]

export const day29 = [
    {value :'1', text:'1일'},
    {value :'2', text:'2일'},
    {value :'3', text:'3일'},
    {value :'4', text:'4일'},
    {value :'5', text:'5일'},
    {value :'6', text:'6일'},
    {value :'7', text:'7일'},
    {value :'8', text:'8일'},
    {value :'9', text:'9일'},
    {value :'10', text:'10일'},
    {value :'11', text:'11일'},
    {value :'12', text:'12일'},
    {value :'13', text:'13일'},
    {value :'14', text:'14일'},
    {value :'15', text:'15일'},
    {value :'16', text:'16일'},
    {value :'17', text:'17일'},
    {value :'18', text:'18일'},
    {value :'19', text:'19일'},
    {value :'20', text:'20일'},
    {value :'21', text:'21일'},
    {value :'22', text:'22일'},
    {value :'23', text:'23일'},
    {value :'24', text:'24일'},
    {value :'25', text:'25일'},
    {value :'26', text:'26일'},
    {value :'27', text:'27일'},
    {value :'28', text:'28일'},
    {value :'29', text:'29일'},
]

export const day31 = [
    {value :'1', text:'1일'},
    {value :'2', text:'2일'},
    {value :'3', text:'3일'},
    {value :'4', text:'4일'},
    {value :'5', text:'5일'},
    {value :'6', text:'6일'},
    {value :'7', text:'7일'},
    {value :'8', text:'8일'},
    {value :'9', text:'9일'},
    {value :'10', text:'10일'},
    {value :'11', text:'11일'},
    {value :'12', text:'12일'},
    {value :'13', text:'13일'},
    {value :'14', text:'14일'},
    {value :'15', text:'15일'},
    {value :'16', text:'16일'},
    {value :'17', text:'17일'},
    {value :'18', text:'18일'},
    {value :'19', text:'19일'},
    {value :'20', text:'20일'},
    {value :'21', text:'21일'},
    {value :'22', text:'22일'},
    {value :'23', text:'23일'},
    {value :'24', text:'24일'},
    {value :'25', text:'25일'},
    {value :'26', text:'26일'},
    {value :'27', text:'27일'},
    {value :'28', text:'28일'},
    {value :'29', text:'29일'},
    {value :'30', text:'30일'},
    {value :'31', text:'31일'},
]
export const onlinePurposeCd = new Map( 
    [
        ['340001', '수업용1'],
        ['340002', '수업용2'],
        ['340003', '평가용'],
        ['340004', '기타']
    ]
);

export const onlineContTypeCd = new Map(
    [
        ['201008', '기본문서형'],
        ['201015', '온라인시험지'],
        ['201016', '온라인워크시트'],
        ['201021', '퀴즈'],
        ['201022', '설문조사'],
        ['201023', '매칭형 게임'],
        ['201025', '토의/토론']
    ]
);

export async function getCodeList(params:any) {
    let result =  await getCsCodeList(params)
    let codes:any = []
    result.data.forEach((item:any)=>{
        codes.push({value: item.code, text: item.codeNm})
    })
    return codes
}
export async function getCodeItem(params:any) {
    let result =  await getCodeItem(params)
    let code:any = {value: result.data.code, text: result.data.codeNm}
    return code
}
